import type {
  AiConsultantMessageResult,
  AiConsultantPostPayload,
} from './ai-consultant.backend-model';
import {
  AiConsultantMessageRole,
  type AiConsultantChatHistory,
  type AiConsultantMessage,
} from './ai-consultant.model';

export function transformAiConsultantMessage(
  response: AiConsultantMessageResult,
  request: AiConsultantPostPayload,
): AiConsultantChatHistory {
  return {
    id: response.id,
    history: [
      ...request.history,
      {
        role: AiConsultantMessageRole.ASSISTANT,
        content: response.reply,
      } as AiConsultantMessage,
    ],
  };
}
